<template>
  <div id="app">
  <HomeLanding />
  </div>
</template>

<style src="./assets/custom.css"></style> 

<script>
    import HomeLanding from './components/HomeLanding'
    export default {
        name:'App',
        components:{
          HomeLanding
        },
        mounted() {
          if (this.$store.getters.user.theme == 1) {
            const link = document.createElement('link');
            link.rel = 'stylesheet';
            link.href = '/themes/light-theme.css';
            link.id = 'theme-css';
            document.head.appendChild(link);
          }
        }
    }
</script>     
